'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alias = require('./alias');

var _alias2 = _interopRequireDefault(_alias);

var _STR_TABLE_CELL = require('./_constants/STR_TABLE_CELL');

var _STR_TABLE_CELL2 = _interopRequireDefault(_STR_TABLE_CELL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Alias for the td tag. The TableCell element defines a single cell of a TableRow.
 *
 * @module TableCell
 * @func
 * @since 1.0.0
 * @param {Object} props
 */

var TableCell = (0, _alias2.default)('td', _STR_TABLE_CELL2.default);

exports.default = TableCell;